import React from "react";
import styles from "./ResponsiveLoader.module.css";
import { CircularProgress } from "@mui/material";

const ResponsiveLoader = ({
  loading,
  message = "Loading, please wait...",
  background = "rgba(0, 0, 0, 0.5)",
}) => {
  if (!loading) return null;

  return (
    // <div className={styles.overlay} style={{ backgroundColor: background }}>
    //   <div className={styles.loader}>
    //     <div className={styles.ball}></div>
    //     <div className={styles.ball}></div>
    //     <div className={styles.ball}></div>
    //   </div>
    // </div>

    // 2222

    // <div className={styles.overlay}>
    //   <div className={styles.loader}>
    //     <div className={styles.ball}></div>
    //     <div className={styles.ball}></div>
    //     <div className={styles.ball}></div>
    //   </div>
    //   <div className={styles.message}>{message}</div>
    // </div>

    // 3333

    <div className={styles.overlay}>
      <div className={styles.loader}>
        <CircularProgress />
        <div className={styles.message}>{message}</div>
      </div>
    </div>
  );
};

export default ResponsiveLoader;
